module.exports = __webpack_public_path__ + "static/media/layout-2.d7d82fce.jpg";